module.exports = __webpack_public_path__ + "img/icon-shrink.85ce6beb.svg";